// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.service-detail-row + .service-detail-row[data-v-d35d9d66] {\r\n  border-top: 1px solid #e9ecef;\n}\r\n", ""]);
// Exports
module.exports = exports;
